import { CustomEntityService } from '../../apiclient/api/customEntity.service';
import { UserSessionService } from '../../UserSession/user-session.service';

import { DefaultEditor } from 'ng2-smart-table';
import { Component, Input, OnInit } from '@angular/core';
import { CustomEntityUtils } from './../../custom-entity-utils.service';

@Component({
  template: `

  <div>

    <angular2-multiselect [data]=entities [(ngModel)]="joinsConfig.entity"
    (onSelect)="changeEntity($event)"
            [settings]="dropdownSettings"></angular2-multiselect>

  </div>

  <div *ngIf="elementsSelect != null">



    <angular2-multiselect [data]=elementsSelect [(ngModel)]="joinsConfig.element"
    (onSelect)="changeElement($event)"
            [settings]="dropdownSettings2"></angular2-multiselect>
  </div>

  `,
})
export class TypePropertyFieldListElementComponent extends DefaultEditor implements OnInit {
  entities:any;
  relaciones:any = {};
  dropdownSettings = {
    singleSelection: true,
    selectAllText:'Select All',
    unSelectAllText:'UnSelect All',
    enableSearchFilter: true,
    labelKey:"name",
    searchPlaceholderText:"Buscar",
    text:"Seleccione Entidad"
  };
  dropdownSettings2 = {
    singleSelection: true,
    selectAllText:'Select All',
    unSelectAllText:'UnSelect All',
    enableSearchFilter: true,
    labelKey:"name",
    searchPlaceholderText:"Buscar",
    text:"Seleccione Elemento"
  };
  relacionesSimples:any;
  renderValue: string;
  mostrarRelaciones: boolean = false;
  elementsSelect: any = null;
  joinsConfig:any = {};
  @Input() value: string | number;
  @Input() rowData: any;


  constructor(
    private customEntityUtils: CustomEntityUtils,
    private userSessionService : UserSessionService,
    private customEntityService: CustomEntityService,) {
    super();

    }

   async ngOnInit() {
    this.renderValue = this.cell.newValue;
    this.entities = (await this.customEntityUtils.getEntities()).sort((a, b) => (a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1));

    if ( (await this.customEntityUtils.getCurrentEntity()).geospatial == true){
      this.entities = this.entities.filter(entity => entity.geospatial != true);
    }
    if(this.cell.newValue != ''){
      this.joinsConfig.entity = [this.entities.filter(entity => entity.name == this.cell.getRow().cells[0].newValue)[0]];
      this.changeEntity(null);
      this.joinsConfig.element = [this.elementsSelect.find(e => e.id ==this.cell.newValue)];
    }
  }

  changeEntity(evento){
    this.elementsSelect = this.entities.filter(element => element.id == this.joinsConfig.entity[0].id)[0].elements.sort((a, b) => (a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1));
  }

  changeElement(evento){
    this.cell.newValue = this.joinsConfig.element[0].id;
    this.cell.getRow().cells[0].newValue =this.joinsConfig.entity[0].name;
    this.cell.getRow().getData()["name"] = this.joinsConfig.element[0].name;
    console.log(this.cell.newValue);
  }

}
